<template>
  <div>
    <b-modal
    id="update-status-modal"
    ref="update-status-modal"
    title="更新契約狀態"
    size="lg"
    centered
    hide-footer
    header-class="head-modal"
    :no-close-on-backdrop="true"
    v-model="modalShow"
  >
    <b-form-group label-cols="auto" label-cols-lg="auto" label="類型">
      <b-form-select v-model="data.status" :options="options.type" @change="changeType()"></b-form-select>
    </b-form-group>

    <b-form-group v-if="data.status !== 0" label-cols="auto" label-cols-lg="auto" label="期間" label-for="input-default">
      <div class="d-flex">
        <date-picker
          class="mr-2"
          v-model="data.start_date"
          :position="'right'"
          placeholder="開始"
          @dateChange="onStartDateChange"
        ></date-picker>

        <date-picker
          v-if="data.status === 2 || data.status === 4"
          v-model="data.end_date"
          :position="'right'"
          placeholder="結束"
          :max="endMaxDate"
          :disabled="!data.start_date"
        ></date-picker>
      </div>
    </b-form-group>

    <b-form-group v-if="data.status === 1" label-cols="auto" label-cols-lg="auto" label="受理日期">
      <div class="d-flex align-items-center">
        <date-picker
          v-model="data.end_date"
          :position="'right'"
          class="mr-2"
        ></date-picker>

        <span class="text-danger" v-if="!status.isAcceptanceDateSave">*受理日期尚未儲存</span>
      </div>
    </b-form-group>

    <b-form-group v-if="data.status !== 0" label-cols="auto" label-cols-lg="auto" label="備註">
      <b-form-textarea
        v-model="data.remark"
        rows="3"
      />
    </b-form-group>

    <div class="text-center mt-4">
      <b-button
        class="mr-2"
        variant="success"
        size="sm"
        @click="sumit()"
      >
        確定
      </b-button>
      <b-button
        variant="danger"
        size="sm"
        class="mr-4"
        @click="$bvModal.hide('update-status-modal')"
      >
        取消
      </b-button>
    </div>
  </b-modal>
</div>
</template>

<script>
import datePicker from '@/components/common/DatePicker';
import { getTodayDate } from "@/models/HELPERS/common.js";

export default {
  name: 'UpdateContractStatusModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    datePicker
  },
  data () {
    return {
      options: {
        type: []
      },
      status: {
        isAcceptanceDateSave: false
      },
      maxRangeMonths: 6,
      temp_data: {},
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.temp_data = {...this.data};
          this.initData();
        }
      },
      immediate: false
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    endMaxDate() {
      if (this.data.start_date !== null) {
        const end = new Date(this.data.start_date);
        end.setMonth(end.getMonth() + this.maxRangeMonths);

        // 获取年、月、日
        const year = end.getFullYear();
        const month = String(end.getMonth() + 1);
        const day = String(end.getDate());

        // 格式化日期为 'YYYY-MM-DD' 格式
        const formatted = `${year}-${month}-${day}`;

        return formatted;
      }
    },
  },
  methods: {
    initData() {
      const data = this.data;

      switch (data.status) {
        case 1:
          this.$set(data, 'start_date', data.dead_at);
          this.$set(data, 'end_date', data.accept_at);
          this.$set(data, 'remark', data.dead_remark);
          break;
        case 2:
          this.$set(data, 'start_date', data.stop_at);
          this.$set(data, 'end_date', data.stop_end);
          this.$set(data, 'remark', data.stop_remark);
          break;
        case 3:
          this.$set(data, 'start_date', data.exclusion_at);
          this.$set(data, 'remark', data.exclusion_remark);
          break;
        case 4:
          this.$set(data, 'start_date', data.behalf_at);
          this.$set(data, 'end_date', data.behalf_end);
          this.$set(data, 'remark', data.behalf_remark);
          break;
      }

      this.status.isAcceptanceDateSave = data.end_date ? true : false;
      this.initAcceptanceDate();
      this.initOptions();
    },
    // 初始化受理日期
    initAcceptanceDate() {
      this.$nextTick(() => {
        const data = this.data;

        if (data.status === 1 && !data.accept_at) {
          this.$set(data, 'end_date', getTodayDate());
        }
      })
    },
    // 初始化下拉選單
    initOptions() {
      let base_type = [
        { value: 0, text: '正常' },
        { value: 2, text: '停效' },
        { value: 3, text: '除會' },
        { value: 4, text: '墊繳' },
      ];

      if (this.data.status === 0 || this.data.status === 1) {
        base_type.splice(1, 0, { value: 1, text: '身故' });
      }

      this.options.type = base_type;
    },
    sumit() {
      this.$emit('sumit');
    },
    onStartDateChange() {
      const start = new Date(this.data.start_date);
      const end = new Date(this.data.end_date);

      start.setMonth(start.getMonth() + this.maxRangeMonths);

      if (start < end || !this.data.start_date) this.data.end_date = '';
    },
    changeType() {
      const data = this.data;

      if (data.status === this.temp_data.status) {
          this.initData();
      } else {
        this.$set(data, 'start_date', '');
        this.$set(data, 'end_date', '');
        this.$set(data, 'remark', '');
      }

      this.initAcceptanceDate();
    }


  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/UpdateContractStatusModal.vue